import React, { useState } from "react";
import styles from "./styles.module.scss";

import AddressForm from "../addressFormSlide";
import SlideNavigation, { OnNavigationType } from "../_basic/SlideNavigation";
import SeparateFormSlide from "../separatedFormSlide";
import { FormTypes, InputField } from "../../../types/form";

interface FormProps {
  data: FormTypes;
  onNavigation: OnNavigationType;
  setPayloadValue?: any;
}

const FormSlide: React.FC<FormProps> = ({
  data,
  onNavigation,
  setPayloadValue,
}) => {
  const [inputValue, setInputValue] = useState<Record<string, string>>({});

  const [errors, setErrors] = useState<Record<string, string>>({});

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneRegex = /^(?:\+39|0039)?[1-9][0-9]{8,9}$/;

  const validateInput = (field: InputField, value: string) => {
    let error = "";

    if (field.errorMessages?.required && !value) {
      error = field.errorMessages.required;
    } else if (field.type === "email") {
      if (!emailRegex.test(value)) {
        error = field.errorMessages?.invalid || "Invalid email format";
      }
    } else if (field.type === "phone") {
      if (!phoneRegex.test(value)) {
        error = field.errorMessages?.invalid || "Invalid phone number.";
      }
    } else if (field.type === "name") {
      const nameParts = value.trim().split(" ");
      if (nameParts.length < 2) {
        error =
          field.errorMessages?.required || "Please enter first and last name.";
      }
    }

    return error;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: InputField
  ) => {
    const { name, value } = e.target;

    if (field.type === "phone" && !/^[\d+\s-]*$/.test(value)) {
      console.warn("Invalid phone input");
      return;
    }

    setInputValue((prev) => ({ ...prev, [name]: value }));
    const validationError = validateInput(field, value);
    setErrors((prev) => ({ ...prev, [name]: validationError }));
  };

  const renderField = (field: InputField) => {
    if (!field) return null;

    return (
      <div className={styles.inputGroup} key={field.label}>
        {field.options ? (
          <div className={styles.selectField}>
            {field.options.map((option) => (
              <div key={option.value} className={styles.radioButton}>
                <input
                  type="radio"
                  className={styles.radioInput}
                  id={`${field.label.replace(/\s+/g, "-").toLowerCase()}-${
                    option.value
                  }`}
                  name={field.apiFieldName}
                  value={option.value}
                />
                <label
                  htmlFor={`${field.label.replace(/\s+/g, "-").toLowerCase()}-${
                    option.value
                  }`}>
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        ) : (
          <>
            <div className={styles.errorLabel}>
              <label className={styles.inputLabels} htmlFor={field.fieldName}>
                {field.label}
              </label>
              {errors[field.fieldName] && (
                <div className={styles.errorMessages}>
                  <p className={styles.errorText}>{errors[field.fieldName]}</p>
                </div>
              )}
            </div>
            <input
              className={`${styles.inputField} ${
                errors[field.fieldName] && styles.errorBorder
              }`}
              type={field.type}
              onChange={(e) => handleInputChange(e, field)}
              id={field.fieldName}
              data-testid="form_input"
              name={field.fieldName}
              placeholder={field.placeholder}
              value={inputValue[field.fieldName]}
            />
          </>
        )}
        {/* 
        {field.errorMessages && (
          <div className={styles.errorMessages}>
            {Object.values(field.errorMessages).map((error, idx) => (
              <p key={idx} className={styles.errorText}>
                {error}
              </p>
            ))}
          </div>
        )} */}
      </div>
    );
  };

  return (
    <div className={styles.formContainer}>
      <form className={styles.formElement}>
        <AddressForm
          data={data}
          onNavigation={onNavigation}
          setPayloadValue={setPayloadValue}
        />
        {/* {renderField(data.nameInput)}
        {renderField(data.phoneInput)}
        {renderField(data.emailInput)} */}
        {/* <SeparateFormSlide
          data={data.nameInput}
          onNavigation={onNavigation}
          // submitData={submitData}
          setPayloadValue={setPayloadValue}
        /> */}
      </form>

      {data.privacyPolicyText && (
        <p className={styles.privacyNotice}>{data.privacyPolicyText}</p>
      )}

      <SlideNavigation
        onNavigation={() => onNavigation(1)}
        nextText={"Next"}
        selected={[12]}
      />
    </div>
  );
};

export default FormSlide;
